import { ReactNode } from "react";

type MobileCardProps = {
  title?: string;
  children: ReactNode;
  className?: string;
};

/**
 * モバイル版汎用カード（白背景 + 16px 角丸 + 影）
 */
export const MobileCard = ({ title, children, className }: MobileCardProps) => {
  return (
    <section className={`mobile-card ${className ?? ""}`}>
      {title && <h2 className="mobile-card-title">{title}</h2>}
      {children}
    </section>
  );
};
